const preferenceFieldName = (typeCode, channel) => `${typeCode}__${channel}`;

const getPreferencesFromResult = result => {
  const data = result?.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.data)) {
    return data.data;
  }
  return null;
};

const mapPreferencesToFormValues = preferences =>
  (preferences ?? []).reduce(
    (values, preference) => ({
      ...values,
      [preferenceFieldName(preference.typeCode, 'emailEnabled')]:
        !!preference.emailEnabled,
      [preferenceFieldName(preference.typeCode, 'inAppEnabled')]:
        !!preference.inAppEnabled,
    }),
    {},
  );

const mapFormValuesToPayload = (preferences, values) => ({
  preferences: (preferences ?? []).map(preference => ({
    typeCode: preference.typeCode,
    emailEnabled:
      !!values[preferenceFieldName(preference.typeCode, 'emailEnabled')],
    inAppEnabled:
      !!preference.inAppMandatory ||
      !!values[preferenceFieldName(preference.typeCode, 'inAppEnabled')],
  })),
});

export {
  getPreferencesFromResult,
  mapFormValuesToPayload,
  mapPreferencesToFormValues,
  preferenceFieldName,
};
